const debug = false
const environment = 'kdcaProduction'
const apiversion = 1
const language = 'es'

const api = {
  andorra: {
    url: 'http://localhost:9001/api/KDCA',
    widgetUrl: '',
    apikey: '',
    apphash: '',
    xenioId: null
  },
  inditex: {
    url: 'http://localhost:8005/api/DiccionarioLeads',
    widgetUrl: '',
    apikey: '',
    apphash: '',
    xenioId: null
  },
  kdcaDevelop: {
    url: 'https://pre-api.kdca.ai/api/KDCA',
    widgetUrl: 'https://pre-api.kdca.ai/Widget/',
    apikey: '',
    apphash: '',
    xenioId: null
  },
  kdcaProduction: {
    url: 'https://api.kdca.ai/api/KDCA',
    widgetUrl: 'https://api.kdca.ai/Widget/',
    apikey: '',
    apphash: '',
    xenioId: '67c0596e-2442-438a-94c4-2532eaabea7b'
  },
  desigualDesa: {
    url: 'https://desigualapikdca.chatbotchocolate.com/api/KDCA',
    widgetUrl: '',
    apikey: '',
    apphash: '',
    xenioId: null
  },
  desigualProduction: {
    url: 'https://chatbotpck.desigual.com/api/KDCA',
    widgetUrl: '',
    apikey: '',
    apphash: '',
    xenioId: null
  },
  iberdrolaPre: {
    url: 'https://pru-iberdrola-kdca-code.chatbotchocolate.com/api/KDCA',
    widgetUrl: '',
    apikey: '',
    apphash: '',
    xenioId: ''
  },
  iberdrolaProduction: {
    url: 'https://iberdrola-kdca-code.chatbotchocolate.com/api/KDCA',
    widgetUrl: '',
    apikey: '',
    apphash: '',
    xenioId: ''
  }
}

export default {
  api: {
    url: api[environment].url,
    widgetUrl: api[environment].widgetUrl,
    version: apiversion,
    xenioId: api[environment].xenioId
  },
  headers: {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    apiKey: api[environment].apikey,
    language: language,
    Authorization: '',
    os: 'Android'
  },
  apphash: api[environment].apphash,
  debug
}



// WEBPACK FOOTER //
// ./src/env.js